// extracted by mini-css-extract-plugin
module.exports = {"link":"HomeMenu_link__7oCc-","activeLink":"HomeMenu_activeLink__3DJcX"};